module.exports = __webpack_public_path__ + "static/media/ic_profile.4127847e.svg";